import { gql } from "gql";

/**
 * Состояние задачи целиком: у однократной — срок и отметка о выполнении, у повторяемой —
 * расписание и следующее срабатывание. Один фрагмент на все экраны: союз маленький,
 * а разбирать его по полям в каждом фрагменте дороже, чем дочитать пару скаляров.
 */
export const TASK_COMPLETION_STATE_FRAGMENT = gql(/* GraphQL */ `
  fragment TaskCompletionState on TaskDto {
    completion {
      __typename
      ... on OneTimeCompletionDto {
        dueDate
        isDone
        completedDate
      }
      ... on RecurringCompletionDto {
        start
        frequency
        until
        nextDueDate
        status
        closedDate
      }
    }
  }
`);
